import { useNavigate } from '@tanstack/react-router';
import { useCallback, useEffect } from 'react';

import { inputsDbAtoms } from '@/features/inputs-db/inputs-db.atoms';

import {
  disableDebugStream,
  enableDebugStream,
  setupCkDebugListeners,
  triggerManualSnapshot,
} from './ck-debug.ipc';
import { ckDebugStore } from './ck-debug.store';

export function useCkDebugPageSetup() {
  useEffect(() => {
    ckDebugStore.enterPage();

    const controller = new AbortController();
    setupCkDebugListeners(controller.signal);
    enableDebugStream();
    triggerManualSnapshot();

    return () => {
      controller.abort();
      disableDebugStream();
      ckDebugStore.leavePage();
    };
  }, []);
}

export function useOpenInputsForCkJobId() {
  const navigate = useNavigate();

  return useCallback(
    (ckJobId: string) => {
      inputsDbAtoms.showInputsForCkJobId(ckJobId);
      navigate({ to: '/ingestion' });
    },
    [navigate]
  );
}
